var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"my-6 px-4",attrs:{"justify":"center","align":"center"}},[_c('v-col',{staticClass:"py-0 pb-4 pb-sm-0",attrs:{"cols":"12","sm":"4"}},[_vm._t("empresa")],2),_c('v-col',{staticClass:"py-0",attrs:{"cols":"12","sm":"4"}},[_vm._t("sucursal")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }